import { array, string } from 'fp-ts';
import { Eq } from 'fp-ts/Eq';
import { WithAccountId } from '@mews-commander/types';
import { IconName } from '@optimus-web/icons';
import { useResolveRoute } from '@mews/routing';
import { isAccountIdCompany } from '@mews-commander/legacy-entities/src/selectors/bills';
import { getCompanyName, getCustomerFullName } from '@mews-commander/legacy-entities/src/ducks';
import { useCommanderSelector } from '@mews-commander/utils';
import { getCompanyDetailUrl } from '../app/actions/companies';
import { getCustomerDetailUrl } from '../app/actions/customer';

const eq: Eq<string[]> = array.getEq(string.Eq);
export const isEqualWithUndefined = (arg1: string[] | undefined, arg2: string[]) =>
    arg1 !== undefined && eq.equals(arg1, arg2);

export const useGetInfoAccount = ({ accountId }: WithAccountId) => {
    const isCompany = useCommanderSelector((state) => (accountId ? isAccountIdCompany(state, { accountId }) : false));

    const getIconValue = () => (isCompany ? IconName.Companies : IconName.Profile);

    const resolveRoute = useResolveRoute();
    const urlSelector = isCompany ? getCompanyDetailUrl : getCustomerDetailUrl;
    const url = useCommanderSelector((state) =>
        accountId ? urlSelector(state, { id: accountId, resolveRoute }) : undefined
    );

    const selector = isCompany ? getCompanyName : getCustomerFullName;
    const name = useCommanderSelector((state) => (accountId ? selector(state, { id: accountId }) : undefined));

    const iconValue = accountId ? getIconValue() : null;

    return { url, iconValue, name, isCompany };
};
